export default {
    notifications: {
        upload_success: 'Files uploaded successfully',
        update_success: 'Record updated successfully',
    },
    upload_error: 'File size is too large: {fileName}',
    upload_error_mime_type: 'Invalid file type. Allowed types are: pdf, jpg, jpeg, png',
    upload_error_common: 'An error occurred while uploading the files. Please try again.',
    upload_error_oversize: 'File exceeds the maximum allowed size of 50MB.',
}
